import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';
import { getExportDocumentName } from '../utils/export-type-labels';

@Pipe({
    name: 'exportDocumentName',
    standalone: false
})
export class ExportDocumentNamePipe implements PipeTransform {
  constructor(private readonly datePipe: DatePipe) {}

  transform(doc: { visibleName?: string; type?: string; createdAt?: string }): string {
    return getExportDocumentName(doc, value =>
      this.datePipe.transform(value, `${environment.defaultDateFormat} ${environment.defaultTimeFormat}`),
    );
  }
}
